module.exports = __webpack_public_path__ + "img/QR_code.0135ba52.png";